<template>
    <component :is="lazyTemplate">
        <v-layout justify-center align-center>
            <v-responsive width="100vw" max-width="1200" class="py-8">
                <v-card width="100%">
                    <v-card-title class="tit tit--lg">
                        <span class="py-4 pl-4"><b>개인정보 취급방침</b></span>
                    </v-card-title>
                    <v-divider/>
                    <v-card-text>
                        <v-responsive max-height="60vh" class="overflow-auto">
                            <div v-html="termsItem.content"></div>
                        </v-responsive>
                    </v-card-text>
                </v-card>
            </v-responsive>
        </v-layout>
    </component>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return {
            termsItem: null
        };
    },
    async mounted(){
        await this.init();
    },
    methods: {
        async init(){
            let { termsList } = await api.v1.terms.gets({ params: { code: "privacy" } });
            this.termsItem = termsList[0];
        }
    },
    computed: {
        lazyTemplate(){
            return () => import(`@/templates/${this.$theme.pages.login}`);
        }
    }
}
</script>